import { logger } from '../../../../utils/logger';

const ensureBase64Prefix = (imageString: string): string => {
    // If it's an HTTP/HTTPS URL, return as-is
    if (imageString.startsWith('http://') || imageString.startsWith('https://')) {
        return imageString;
    }
    // If it already has the data: prefix, return as-is
    if (imageString.startsWith('data:image')) {
        return imageString;
    }
    // Otherwise, assume it's a raw base64 string and add the prefix
    return `data:image/jpeg;base64,${imageString}`;
};

export const getCroppedImage = (imageSrc: string, crop: { x: number; y: number; width: number; height: number }): Promise<string> => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.src = ensureBase64Prefix(imageSrc);

        image.onload = () => {
            const scaleX = image.naturalWidth / image.width;
            const scaleY = image.naturalHeight / image.height;

            const cropWidth = crop.width * scaleX;
            const cropHeight = crop.height * scaleY;

            const aspectRatio = cropWidth / cropHeight;
            let finalWidth = cropWidth;
            let finalHeight = cropHeight;

            if (cropWidth > cropHeight) {
                finalWidth = Math.min(350, cropWidth);
                finalHeight = finalWidth / aspectRatio;
            } else {
                finalHeight = Math.min(350, cropHeight);
                finalWidth = finalHeight * aspectRatio;
            }

            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            canvas.width = finalWidth;
            canvas.height = finalHeight;

            ctx?.drawImage(
                image,
                crop.x * scaleX,
                crop.y * scaleY,
                crop.width * scaleX,
                crop.height * scaleY,
                0,
                0,
                finalWidth,
                finalHeight
            );

            resolve(canvas.toDataURL('image/jpeg'));
        };

        image.onerror = (error) => {
            logger.error("Image load failed", error);
            reject(new Error("Image load failed"));
        };
    });
};
